var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html } from 'lit';
import { property } from 'lit/decorators.js';
import { ifDefined } from 'lit/directives/if-defined.js';
import { BlocksElement } from '../../BlocksElement';
import styles from '../icon.styles';
/**
 * EmailReply component
 * @csspart base- The component's base wrapper
 */
export class BlocksIconEmailReply extends BlocksElement {
    static { this.styles = styles; }
    connectedCallback() {
        super.connectedCallback();
        this.classList.add('cat-icon');
    }
    render() {
        const componentClassName = this.componentClassNames('cat-c-icon cat-c-icon-bi-directional', {
            'cat-c-icon--sm': this.size === 'sm',
            'cat-c-icon--lg': this.size === 'lg',
            'cat-c-icon--xl': this.size === 'xl',
            'cat-c-icon--content-strong': this.color === 'content-strong',
            'cat-c-icon--knockout': this.color === 'knockout',
            'cat-c-icon--knockout-brand': this.color === 'knockout-brand',
            'cat-c-icon--information': this.color === 'information',
            'cat-c-icon--success': this.color === 'success',
            'cat-c-icon--warning': this.color === 'warning',
            'cat-c-icon--error': this.color === 'error'
        });
        return html `
      <span part="base" class="${componentClassName}" role="presentation">
        <svg
          aria-hidden="${!this.iconTitle}"
          aria-label="${ifDefined(this.iconTitle)}"
          role="${this.iconTitle && 'img'}"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M17.2123 15.6519C17.5052 15.359 17.5052 14.8841 17.2123 14.5913C16.9194 14.2984 16.4445 14.2984 16.1516 14.5913L13.8174 16.9255C13.7886 16.9536 13.7619 16.9841 13.7379 17.0165C13.6455 17.1412 13.5908 17.2955 13.5908 17.4626C13.5908 17.4665 13.5908 17.4704 13.5909 17.4743C13.5921 17.5553 13.6064 17.6362 13.6338 17.7135C13.6699 17.8156 13.7288 17.9114 13.8105 17.9931L16.1516 20.3342C16.4445 20.6271 16.9194 20.6271 17.2123 20.3342C17.5052 20.0413 17.5052 19.5665 17.2123 19.2736L16.1514 18.2126H19.0231C19.6521 18.2126 20.2553 18.4625 20.7001 18.9073C21.1448 19.352 21.3947 19.9552 21.3947 20.5842V22.145C21.3947 22.5592 21.7305 22.895 22.1447 22.895C22.5589 22.895 22.8947 22.5592 22.8947 22.145V20.5842C22.8947 19.5574 22.4868 18.5726 21.7607 17.8466C21.0347 17.1205 20.0499 16.7126 19.0231 16.7126H16.1516L17.2123 15.6519Z"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M2.84196 2.84245C2.99401 2.6904 3.20023 2.60498 3.41526 2.60498H19.023C19.238 2.60498 19.4442 2.6904 19.5963 2.84245C19.7483 2.9945 19.8337 3.20072 19.8337 3.41575V3.43327L11.2192 9.52089L2.60449 3.43318V3.41575C2.60449 3.20072 2.68991 2.9945 2.84196 2.84245ZM1.10449 3.82101V14.3411C1.10449 14.954 1.34795 15.5417 1.7813 15.9751C2.21465 16.4084 2.80241 16.6519 3.41526 16.6519H10.4387C10.8529 16.6519 11.1887 16.3161 11.1887 15.9019C11.1887 15.4877 10.8529 15.1519 10.4387 15.1519H3.41526C3.20023 15.1519 2.99401 15.0665 2.84196 14.9144C2.68991 14.7624 2.60449 14.5562 2.60449 14.3411V5.26992L10.7863 11.0518C11.0458 11.2351 11.3926 11.2351 11.652 11.0518L19.8337 5.27001V12.7804C19.8337 13.1946 20.1695 13.5304 20.5837 13.5304C20.9979 13.5304 21.3337 13.1946 21.3337 12.7804V3.83453C21.3339 3.82548 21.3339 3.81643 21.3337 3.80737V3.41575C21.3337 2.8029 21.0903 2.21514 20.6569 1.78179C20.2236 1.34844 19.6358 1.10498 19.023 1.10498H3.41526C2.80241 1.10498 2.21465 1.34844 1.7813 1.78179C1.34795 2.21514 1.10449 2.8029 1.10449 3.41575V3.82088C1.10449 3.82093 1.10449 3.82097 1.10449 3.82101Z"
          />
        </svg>
      </span>
    `;
    }
}
__decorate([
    property({ type: String })
], BlocksIconEmailReply.prototype, "color", void 0);
__decorate([
    property({ type: String })
], BlocksIconEmailReply.prototype, "iconTitle", void 0);
__decorate([
    property({ type: String })
], BlocksIconEmailReply.prototype, "size", void 0);
if (customElements.get('cat-icon-email-reply') === undefined) {
    customElements.define('cat-icon-email-reply', BlocksIconEmailReply);
}
